function initHermesAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn("GSAP or ScrollTrigger not loaded.");
    return;
  }
  
  gsap.registerPlugin(ScrollTrigger);

  // 1. Page Load: Product Images (Left side) with Parallax
  const mediaItems = document.querySelectorAll('.product__media-item');
  if (mediaItems.length > 0) {
    gsap.fromTo(mediaItems, 
      { opacity: 0, y: 30 }, 
      { opacity: 1, y: 0, duration: 1, stagger: 0.15, ease: 'power3.out', delay: 0.1 }
    );
  }
  
  // Parallax effect on scroll for the image wrapper
  const mediaWrapper = document.querySelector('.hermes-product-media-wrapper');
  if (mediaWrapper) {
    gsap.to(mediaWrapper, {
      y: 80, // Move down slightly as you scroll down
      ease: 'none',
      scrollTrigger: {
        trigger: '.hermes-product-top',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });
  }

  // 2. Page Load: Floating Card (3D Swing entrance)
  const floatingCard = document.querySelector('.hermes-floating-card');
  if (floatingCard) {
    gsap.fromTo(floatingCard,
      { opacity: 0, x: 50, rotationY: -15, transformPerspective: 1000 },
      { opacity: 1, x: 0, rotationY: 0, duration: 1.2, ease: 'power3.out', delay: 0.2 }
    );
  }
  
  // 3. Color Swatches Pop & Bounce Stagger
  const swatches = document.querySelectorAll('.otherproductscolors a, .block-swatch, .color-swatch');
  if (swatches.length > 0) {
    gsap.fromTo(swatches,
      { scale: 0, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.6, stagger: 0.05, ease: 'back.out(1.7)', delay: 0.6 }
    );
    
    // Bouncy hover state
    swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => gsap.to(swatch, { scale: 1.15, duration: 0.2, ease: 'power1.out' }));
      swatch.addEventListener('mouseleave', () => gsap.to(swatch, { scale: 1, duration: 0.2, ease: 'power1.out' }));
    });
  }

  // 4. ScrollTrigger: Bottom Left Description
  const bottomLeft = document.querySelector('.hermes-bottom-left');
  if (bottomLeft) {
    gsap.fromTo(bottomLeft,
      { opacity: 0, y: 40 },
      {
        opacity: 1, y: 0, duration: 1, ease: 'power3.out',
        scrollTrigger: {
          trigger: bottomLeft,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  }

  // 5. ScrollTrigger: Bottom Right Accordions & Buttons
  const bottomRightElements = document.querySelectorAll('.hermes-bottom-right > div');
  if (bottomRightElements.length > 0) {
    gsap.fromTo(bottomRightElements,
      { opacity: 0, y: 30 },
      {
        opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: {
          trigger: '.hermes-bottom-right',
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  }

  // 6. ScrollTrigger: The Story Behind (Staggered Children)
  const storyElements = document.querySelectorAll('.hermes-story-section > *');
  if (storyElements.length > 0) {
    gsap.fromTo(storyElements,
      { opacity: 0, y: 40 },
      {
        opacity: 1, y: 0, duration: 1, stagger: 0.2, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.hermes-story-section',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  }

  // 7. Interactive Hover Effects (Buttons and Accordions)
  const atcButton = document.querySelector('.product-form__add-button, .product-form__buttons button');
  if (atcButton) {
    atcButton.addEventListener('mouseenter', () => {
      gsap.to(atcButton, { 
        scale: 1.02, 
        boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.18)",
        duration: 0.2, 
        ease: 'power1.out' 
      });
    });
    atcButton.addEventListener('mouseleave', () => {
      gsap.to(atcButton, { 
        scale: 1, 
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0)",
        duration: 0.2, 
        ease: 'power1.out' 
      });
    });
  }

  const accordionHeaders = document.querySelectorAll('.hermes-accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('mouseenter', () => {
      gsap.to(header, { x: 5, duration: 0.2, ease: 'power1.out' });
    });
    header.addEventListener('mouseleave', () => {
      gsap.to(header, { x: 0, duration: 0.2, ease: 'power1.out' });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHermesAnimations);
} else {
  initHermesAnimations();
}
